import type { ChargingActivitySummaryType } from '@/api/schema';

import type { ChartDataPoint } from './types';

export const transformToChartData = (dailyData: ChargingActivitySummaryType[]): ChartDataPoint[] =>
    dailyData.map(data => ({
        date: data.chargingActivityDate,
        energy: data.totalEnergyCharged ?? 0,
        costs: data.totalChargingCost ?? 0,
        sessions: data.numberOfChargingSessions,
    }));
